import React, { useState, useMemo, use, useEffect } from 'react'
import { Box, Button, Typography, Grid } from '@mui/material'
import StyledSwitch from '../common/StyledSwitch'
import { getClientName } from '../../api/premiumFeature'
import { sanitizeForLog } from '../../constants/index'
import CustomInput from '../Returns/CustomInput'


const LDCAndChallanReaderFrom = ({
  formData,
  handleFormSubmit,
  formErrors,
  isEdit,
  formLoading,
  onInputChange,
  setFormData
}) => {
  const fetchClientData = async () => {
    try {
      const response = await getClientName()
      const clientDetails = response.data
      setFormData(prevFormData => ({
        ...prevFormData,
        clientName: clientDetails.clientName || clientDetails.clientUuid,
        clientUuid: clientDetails.clientUuid,
        enableLdcChallan: true
      }))
    } catch (error) {
      console.error('Error fetching client data:', sanitizeForLog(error?.message || 'Unknown error'))
    }
  }
  useEffect(() => {
    if (formData.uuid) return

    fetchClientData()
  }, [formData.uuid])

  console.log(formData, 'formData', formErrors, 'formErrors');

  return (
    <>
      <Typography
        variant="body2"
        sx={{ color: 'var(--forbrand-error)', mb: 4, fontSize: '14px' }}
      >
        (*) Fields are mandatory
      </Typography>

      <Box>
        <form onSubmit={handleFormSubmit}>
          {/* CLIENT DROPDOWN{/* <Box mt={3}>
            <CustomSelect
              label="Client Name"
              value={formData.clientName || ""}
              onChange={(e) => onInputChange("clientName", e.target.value)}
              options={clientOptions}
              getOptionLabel={(o) => o.label}
              getOptionValue={(o) => o.value}
              placeholder="Select Client Name"
              sx={{ width: "100%", height: "56px" }}
            />
            {formErrors.clientName && (
              <Typography variant="caption" color="error">
                {formErrors.clientName}
              </Typography>
            )}
          </Box> */}
          <Box>
            <CustomInput
              label="Client Name"
              value={formData.clientName || ''}
              disabled
              error={!!formErrors.clientName}
              helperText={formErrors.clientName}
            />
          </Box>

          {/* SWITCH */}
          <Grid
            item
            size={6}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              pt: '30px',
            }}
          >
            <Typography
              variant="body1"
              sx={{ fontSize: '16px', color: '#333', fontWeight: 500 }}
            >
              Enable LDC & Challan Pdf Reader
            </Typography>
            <StyledSwitch
              checked={!!formData.enableLdcChallan}
              onChange={e =>
                onInputChange('enableLdcChallan', e.target.checked)
              }
            />
          </Grid>
        </form>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: '32px' }}>
        <Button
          type="submit"
          variant="contained"
          onClick={handleFormSubmit}
          disabled={formLoading || Object.keys(formErrors).length > 0}
          sx={{
            backgroundColor: 'var(--forbrand-bg-variant)',
            color: 'var(--forbrand-brand-varient)',
            textTransform: 'none',
            px: '17px',
            py: '8px',
          }}
        >
          {formLoading ? 'Saving...' : isEdit ? 'Update' : 'Save'}
        </Button>
      </Box>
    </>
  )
}

export default LDCAndChallanReaderFrom
